<div class="d-flex justify-content-center   min-height-100">

  <div *ngIf="loading" class=" row col-12 d-flex justify-content-center mt-5">
    <app-spinner-loading></app-spinner-loading>
  </div>

  <div *ngIf="ticket && !loading" class="row col-12 d-flex justify-content-center mt-5">

    <div class="col-12 col-md-6 row  d-flex justify-content-center mt-5 ">

      <p class="col-12  d-flex justify-content-center" style="font-size: 20px;    margin-bottom: 10px;">
        {{ticket.title}}
      </p>
      <p class="col-12  d-flex justify-content-center" style="font-size: 20px;    margin-bottom: 0px;"> $
        {{ticket.totalPrice | number}} </p>

      <qrcode class="col-12 col-md-6" [elementType]="'img'" [qrdata]=" ticket.id" [errorCorrectionLevel]="'M'">
      </qrcode>


      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        {{ticket.id}}
      </p>
      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        {{ticket.created_at | date : 'dd/MM/yyyy, h:mm a'}}
      </p>

      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        {{ticket.email}}
      </p>
      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        {{ticket.name}}
      </p>

      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        {{ticket.typeEventTicket}}
      </p>


      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        <b>valido en : {{ticket.nameEvent}}</b>
      </p>

      <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
        <b>Metodo de pago : {{ticket.paymentMethod}}</b>
      </p>

    </div>
  </div>
</div>